// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1vihG","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__BQW5p"};